import { withEditable } from '../../../HOCs/withEditable';
import withSortedPlacesThemes from '../../../HOCs/withSortedPlacesThemes';
import ModalSlider from '../../Places/ModalSlider';

export const EditableSliderForServiceModal = withSortedPlacesThemes(
  withEditable(ModalSlider)
);



// WEBPACK FOOTER //
// ./src/screens/Trek/ThemesModal/EditableSliderForServiceModal.js